<script>
    import {getUser, logout} from '../../auth-store';
    import {url} from '@sveltech/routify';
    import {getContext} from "svelte";
    import Chat from "../../components/chat/Chat.svelte";

    import {
        Alert,
        Collapse,
        Navbar,
        NavbarToggler,
        NavbarBrand,
        Nav,
        NavItem,
        NavLink
    } from 'sveltestrap';

    const MyAnalytics = getContext('MyAnalytics');

    let isOpen = false;

    function handleUpdate(event) {
        isOpen = event.detail.isOpen;
    }

    const handleLogout = () => {
        MyAnalytics.logEvent('logout');
        MyAnalytics.setUserId(null);
        logout();
    }
</script>

{#if getUser()}
    <header>
        <Navbar class="navbar navbar-expand-lg navbar-themed" expand="md">
            <NavbarBrand href={$url('/app/campaigns')}>
                <img src="/images/imin-logo-navbar.png" alt="logo" class="img-fluid" width="50">
            </NavbarBrand>
            <NavbarToggler on:click={() => (isOpen = !isOpen)}/>
            <Collapse {isOpen} navbar expand="md" on:update={handleUpdate}>
                <Nav class="ml-auto" navbar>
                    <NavItem>
                        <NavLink href={$url('/app/campaigns')}>Campaigns</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink on:click={ handleLogout }>Logout</NavLink>
                    </NavItem>
                </Nav>
            </Collapse>
        </Navbar>
    </header>
    <main>
        <slot></slot>
    </main>
    <footer>
        <Chat/>
    </footer>

{:else}
    <div class="mx-auto text-center">
        <p>
            <img src="/images/imin-logo-navbar.png" alt="logo" class="img-fluid">
        </p>

        <Alert color="info">
            <h4 class="alert-heading text-capitalize">Not Logged in</h4>
            To use our services to promote your event you need to be logged in with your I'M IN account.<br>
            <a href={$url('/')} class="alert-link">Click here to login.</a>
        </Alert>

    </div>
{/if}